/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BrokerFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return BrokerFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<BrokerFeatureFlagsWithDefaults>): BrokerFeatureFlagsWithDefaults {
        let obj = Object.assign(new BrokerFeatureFlagsWithDefaults(), model);
        BrokerFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BrokerFeatureFlagsWithDefaults>): BrokerFeatureFlagsWithDefaults {
        if (!model) return null;
        return BrokerFeatureFlagsWithDefaults.newInstance(<BrokerFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BrokerFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.BrokerFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BrokerFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BrokerFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    br_2504_a_test_flag: boolean = false;

}
